//         setTimeout(() => {
//             const headerCart = document.querySelector('.header__action-item.header__action-item--cart a')
//             if (headerCart) {
//                 headerCart.addEventListener("click", () => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                             a.classList.add('Bss_checkout1')
//                            a.addEventListener("click", () => {
//                                            let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                                             a.classList.add('Bss_checkout')
//                                             a.style.pointerEvents = 'none';
//                                             a.style.opacity = '0.6';
//                                         })
//                         }
                  
//                      const bss = setInterval(()=>{
//                       let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                             a.classList.add('Bss_checkout1')
//                         }
//                    },50)
//                     setTimeout(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                        clearInterval(bss)
//                         if (a ) {
                          
                           
//                             a.classList.remove('Bss_checkout1')
//                            if (typeof(BSS_B2B) == 'undefined') {
//                                a.style.pointerEvents = 'auto';
//                             a.style.opacity = '1';
//                               a.classList.remove('Bss_checkout')
//                           }
//                         }
//                     }, 4500)

//                 })        
//                   setTimeout(() => {
//             const headerCart = document.querySelector('.header__action-item.header__action-item--cart a')
//             if (headerCart) {
//                 headerCart.addEventListener("click", () => {
//                     let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                     if (a) {
//                         a.classList.add('Bss_checkout1')
//                         a.addEventListener("click", () => {
//                             let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                             a.classList.add('Bss_checkout')
//                             a.style.pointerEvents = 'none';
//                             a.style.opacity = '0.6';
//                         })
//                     }
//                     const bss = setInterval(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                             a.classList.add('Bss_checkout1')
//                         }
//                     }, 50)
//                     setTimeout(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         clearInterval(bss)
//                         if (a) {


//                             a.classList.remove('Bss_checkout1')
//                             if (typeof(BSS_B2B) == 'undefined') {
//                                 a.style.pointerEvents = 'auto';
//                                 a.style.opacity = '1';
//                                 a.classList.remove('Bss_checkout')
//                             }
//                         }
//                     }, 4500)

//                 })
//             }
//             const addCart = document.querySelector('.product-form__add-button.current-cart-icon--cart')
//             if (addCart) {
//                 addCart.addEventListener("click", () => {
//                     let isfirst = true
//                     if (BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.line_item_products.length) {
//                         isfirst = false
//                     }
//                     let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                     if (a) {
//                         a.addEventListener("click", () => {
//                             let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                             a.classList.add('Bss_checkout1')
//                             a.style.pointerEvents = 'none';
//                             a.style.opacity = '0.6';
//                         })

//                     }
//                     const bss = setInterval(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                             a.classList.add('Bss_checkout1')
//                             if (typeof(BSS_B2B) !== 'undefined') {
//                                 a.classList.remove('Bss_checkout')
//                             }
//                         }
//                     }, 50)
//                     setTimeout(() => {
//                         if (isfirst && typeof(BSS_B2B) !== 'undefined') {
//                             console.log('test1')
//                             BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
//                         }

//                     }, 2000)
//                     setTimeout(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         clearInterval(bss)
//                         if (a) {
//                             a.classList.remove('Bss_checkout1')
//                             if (typeof(BSS_B2B) == 'undefined') {
//                                 console.log('test2')
//                                 a.classList.remove('Bss_checkout')
//                                 a.style.pointerEvents = 'auto';
//                                 a.style.opacity = '1';
//                             }

//                         }
//                     }, 4500)
//                 })
//             }
//         }, 1000)
//         if (window.location.pathname.includes("/cart")) {
//             setTimeout(() => {
//                 let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                 setTimeout(() => {
//                     if (a) {
//                         a.classList.add('Bss_checkout')
//                         a.style.pointerEvents = 'none';
//                         a.style.opacity = '0.6';
//                         a.addEventListener("click", () => {
//                             let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                             a.classList.add('Bss_checkout')
//                             a.style.pointerEvents = 'none';
//                             a.style.opacity = '0.6';
//                         })
//                     }
//                 }, 500)
//                 setTimeout(() => {
//                     let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                     if (a && typeof((BSS_B2B) == 'undefined')) {
//                         a.classList.remove('Bss_checkout')
//                         a.style.pointerEvents = 'auto';
//                         a.style.opacity = '1';
//                     }
//                 }, 4000)

//             }, 2000)
//         }
//             }
//             const addCart = document.querySelector('.product-form__add-button.current-cart-icon--cart')
//             if (addCart) {
//                 addCart.addEventListener("click", () => {
//                   let isfirst = true
//                   if (BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.line_item_products.length) {
//                     isfirst = false
//                   }
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                           a.addEventListener("click", () => {
//                                            let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                                            a.classList.add('Bss_checkout1')
//                                             a.style.pointerEvents = 'none';
//                                             a.style.opacity = '0.6';
//                                         })
                            
//                         }
//                    const bss = setInterval(()=>{
//                       let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         if (a) {
//                             a.classList.add('Bss_checkout1')
//                            if (typeof(BSS_B2B) !== 'undefined') {
//                               a.classList.remove('Bss_checkout')
//                           }
//                         }
//                    },50)
//                     setTimeout(() => {
//                       if (isfirst && typeof(BSS_B2B) !== 'undefined') {
//                        
//                            BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
//                       }
                     
//                     }, 2000)
//                     setTimeout(() => {
//                         let a = document.querySelector('.mini-cart__button-container button.button--primary')
//                         clearInterval(bss)
//                         if (a) {
//                             a.classList.remove('Bss_checkout1')
//                           if (typeof(BSS_B2B) == 'undefined') {
//                          console.log('test2')
//                               a.classList.remove('Bss_checkout')
//                              a.style.pointerEvents = 'auto';
//                             a.style.opacity = '1';
//                           }
                           
//                         }
//                     }, 4500)
//                 })
//             }
//         }, 1000)
// if (window.location.pathname.includes("/cart")) {
//   setTimeout(() => {
//                           let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//      setTimeout(() => {
//                                       if (a) {
//                                         a.classList.add('Bss_checkout')
//                                         a.style.pointerEvents = 'none';
//                                         a.style.opacity = '0.6';
//                                         a.addEventListener("click", () => {
//                                            let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                                            a.classList.add('Bss_checkout')
//                                             a.style.pointerEvents = 'none';
//                                             a.style.opacity = '0.6';
//                                         })
//                                       }
//      } , 500)
//                                      setTimeout(() => {
//                                         let a = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button')
//                                         if (a && typeof((BSS_B2B) == 'undefined')) {
//                                             a.classList.remove('Bss_checkout')
//                                             a.style.pointerEvents = 'auto';
//                                             a.style.opacity = '1';
//                                         }
//                                     }, 4000)
    
//                     }, 2000)
// }

// BSS Cart Handling Script



// (function() {
//   function disableCheckoutButton(btn) {
//     if (!btn) return;
//     btn.classList.add('Bss_checkout');
//     btn.style.pointerEvents = 'none';
//     btn.style.opacity = '0.6';
//   }

//   function enableCheckoutButton(btn) {
//     if (!btn) return;
//     btn.classList.remove('Bss_checkout');
//     btn.style.pointerEvents = 'auto';
//     btn.style.opacity = '1';
//   }

//   function handlePrimaryButtonClick() {
//     const btn = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button');
//     disableCheckoutButton(btn);
//   }

//   function handleCheckoutLogic() {
//     const btn = document.querySelector('.mini-cart__button-container button.button--primary');
//     if (!btn) return;

//     disableCheckoutButton(btn);
//     btn.addEventListener("click", handlePrimaryButtonClick);

//     const bss = setInterval(() => {
//       const btn = document.querySelector('.mini-cart__button-container button.button--primary');
//       if (btn) {
//         btn.classList.add('Bss_checkout1');
//         if (typeof BSS_B2B !== 'undefined') {
//           btn.classList.remove('Bss_checkout');
//         }
//       }
//     }, 50);

//     setTimeout(() => {
//       clearInterval(bss);
//       const btn = document.querySelector('.mini-cart__button-container button.button--primary');
//       if (btn) {
//         btn.classList.remove('Bss_checkout1');
//         if (typeof BSS_B2B === 'undefined') {
//           enableCheckoutButton(btn);
//         }
//       }
//     }, 4500);
//   }

//   function setupCartEventListeners() {
//     const headerCart = document.querySelector('.header__action-item.header__action-item--cart a');
//     if (headerCart) {
//       headerCart.addEventListener("click", handleCheckoutLogic);
//     }

//     const addCart = document.querySelector('.product-form__add-button.current-cart-icon--cart');
//     if (addCart) {
//       addCart.addEventListener("click", () => {
//         let isFirst = true;
//         if (BSS_B2B && BSS_B2B.shopData && BSS_B2B.shopData.line_item_products.length) {
//           isFirst = false;
//         }

//         handleCheckoutLogic();

//         setTimeout(() => {
//           if (isFirst && typeof BSS_B2B !== 'undefined') {
//             BSS_B2B.cart.fixer(BSS_B2B.shopData, false, true);
//           }
//         }, 2000);
//       });
//     }
//   }

//   function handleCartPage() {
//     if (window.location.pathname.includes("/cart")) {
//       setTimeout(() => {
//         const btn = document.querySelector('.cart-recap__checkout, .mini-cart__button-container button');
//         setTimeout(() => disableCheckoutButton(btn), 500);

//         setTimeout(() => {
//           if (btn && typeof BSS_B2B === 'undefined') {
//             enableCheckoutButton(btn);
//           }
//         }, 4000);
//       }, 2000);
//     }
//   }

//   // Run setup after delay
//   setTimeout(() => {
//     setupCartEventListeners();
//     handleCartPage();
//   }, 1000);
// })();




document.addEventListener('cart:rerendered', (e) => {
  BSS_B2B.observer.cartSubject.listenCartCheckout()
});
